import dayjs, { Dayjs } from 'dayjs';

export default class AdmissionMetadata {
  id: string;
  name: string;
  socialName?: string;
  email: string;
  dddPhone?: string;
  phone?: string;
  cpf: string;
  birthDate?: Dayjs;
  admissionDate?: Dayjs;
  expirationDate?: Dayjs;
  createdAt: Dayjs;
  professionalIdentification: number;


  constructor(id: string, name: string, socialName: string, email: string, dddPhone: string, phone: string, cpf: string, birthDate: dayjs.Dayjs, admissionDate: dayjs.Dayjs, expirationDate: dayjs.Dayjs, createdAt: dayjs.Dayjs,professionalIdentification: number) {
    this.id = id;
    this.name = name;
    this.socialName = socialName;
    this.email = email;
    this.dddPhone = dddPhone;
    this.phone = phone;
    this.cpf = cpf;
    this.birthDate = birthDate;
    this.admissionDate = admissionDate;
    this.expirationDate = expirationDate;
    this.createdAt = createdAt;
    this.professionalIdentification = professionalIdentification;
  }
}
